const styles = theme => ({
    Application: {
        // height: '100vh',
        minHeight: '100vh',
        backgroundImage: "url(" + process.env.PUBLIC_URL + "/images/hematoxylin-eosin-stain-background.jpg)",
        backgroundSize: '100%',
        display: 'flex',
        flexDirection : 'column',
        justifyContent: 'center',
        alignItems: 'center'
    }
});

export default styles;
